<template>
<div class="chapter">
<div class="inner_page">
<p class="ctl" id="d7e3809"><a href="#/Lema_9781418514020_epub_c15_r1#Anch0019" id="Anch0007">Section One<br/> The Daddy Difference </a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Lema_9781418514020_epub_c16_r1.vue?bcbfcbfc